module.exports = __webpack_public_path__ + "img/dateSingedEle.0d6b6aab.svg";